exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-user-table-sortheader[data-v-35919bf6] {\n  cursor: pointer;\n}\n.select-user-table-nodata[data-v-35919bf6] {\n  border: 1px solid gray;\n}", ""]);

// exports
